<script setup>
// Components
import HeaderTitle from "@/components/layout/HeaderTitle.vue";


import { Cropper } from "vue-advanced-cropper";

// Services
import CollaboratorService from '@/api/services/collaborator.service';
import EmployeeService from '@/api/services/employee.service';
import ProviderService from '@/api/services/provider.service';
import Common from '@/api/services/common.service';


import Notification from '@/utils/plugins/NotificationService'
import { useAuthStore } from "@/app/stores/authStore";
import { useUiStore } from "@/app/stores/uiStore";
import { computed, onMounted, ref } from "vue";
import { useRoute, useRouter } from "vue-router";
import { helpers, required } from "@vuelidate/validators";
import { useVuelidate } from "@vuelidate/core";

const isEditingCollaborator = ref(true)
const title = ref('Colaborador');
const collaborator = ref({});

const cropper = ref(null)
const showModalCropImage = ref(false);
const providers = ref([]);
const image = ref('');
const baseUrl = ref(process.env.VUE_APP_BASE_URI);
const imagePreview = ref(null);
const imageCrop = ref(null);

const uploadedImage = ref(null);
const rules = computed(() => {
  let allRules = {
    name: {
      required: helpers.withMessage("Este campo es obligatorio", required),
    },
    lastName: {
      required: helpers.withMessage("Este campo es obligatorio", required),
    },
    email: {
      required: helpers.withMessage("Este campo es obligatorio", required),
    },
    emailExternal: {
      required: helpers.withMessage("Este campo es obligatorio", required),
    },
    timeZoneSpain: {
      required: helpers.withMessage("Este campo es obligatorio", required),
    },
    countryLocation: {
      required: helpers.withMessage("Este campo es obligatorio", required),
    },
    provider: {
      required: helpers.withMessage("Este campo es obligatorio", required),
    },
  }
  return allRules;
});
const imageUrl = ref(null);

const route = useRoute();
const router = useRouter();
const authStore = useAuthStore();
const uiStore = useUiStore();
const collaboratorsRestoreFiltersStorageKey = 'collaborators-restore-filters';
const user = computed(() => authStore.getUserLogged);
const v$ = useVuelidate(rules, collaborator);
let v = v$.value;
// eslint-disable-next-line no-unused-vars
const props = defineProps({
  profile: { type: Boolean, default: false },
})

onMounted(() => {
  if (ifIsInArray(user.value.roles, 'ROLE_ADMIN')) {
    if (route.params.id && route.params.id === 'new') {
      title.value = 'Nuevo Colaborador'
      collaborator.value = {};
      collaborator.value.dateRegister = null;
      collaborator.value.remote = false;
      collaborator.value.companyInterns = false;
      isEditingCollaborator.value = false;
      collaborator.value.dateStartIntern = null;
      collaborator.value.dateEndIntern = null;
      collaborator.value.timeZoneSpain = false;
    } else {
      getCollaborator(route.params.id);
    }
    getProviders();
  }
})

const changePicture = ({ coordinates, canvas }) => {
  cropper.value = {
    coordinates,
    canvas
  }
}
// Elimina hijos de un nodo
const uploadImage = (event) => {
  // console.log("uploadImage", event);
  // Hace referencia al DOM input element
  const input = event.target;
  // Asegura tener un archivo antes de leerlo
  if (input.files && input.files[0]) {
    // Crea un nuevo FileReader para leer la imagen y la convierte a formato base64
    const reader = new FileReader();
    // Define una funcion callback para que se ejecute cuando FileReader finalice su trabajo
    reader.onload = (e) => {
      // Nota: la función de flecha utilizada aqui, de modo que "imageData" se refiere al componente
      // imageData de Vue.
      // Leemos la imagen como base64 y la establecemos en imageData
      uploadedImage.value = e.target.result;
    }
    // Se inicia el trabajo de lectura, leyendo el archivo como un url datos (en formato base64)
    reader.readAsDataURL(input.files[0]);
  }
}
const cropImage = async () => {
  let image = cropper.value.canvas.toDataURL(
    "image/jpeg"
  );
  imagePreview.value = image;
  image = dataURItoBlob(image);
  await CollaboratorService.uploadImageFile(image)
    .then((res) => {
      // eslint-disable-next-line no-unused-vars
      let id = collaborator.value.photo && collaborator.value.photo.id ? collaborator.value.photo.id : null;

      if (collaborator.value.id) {
        collaborator.value.photo = res.data['@id'];
        // updateEmployee(id);
      } else {
        imagePreview.value = res.data['contentUrl'];
        collaborator.value.photo = res.data['@id'];
      }

    })
    .catch(() => {
      Notification.addNotification('Error al cargar la imagen', 'error', 6000)
    });

  closeModalCropImage();
}

const dataURItoBlob = (dataURI) => {
  let byteString;
  if (dataURI.split(',')[0].indexOf('base64') >= 0)
    byteString = atob(dataURI.split(',')[1]);
  else
    byteString = unescape(dataURI.split(',')[1]);

  // separate out the mime component
  const mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];

  // write the bytes of the string to a typed array
  const ia = new Uint8Array(byteString.length);
  for (let i = 0; i < byteString.length; i++) {
    ia[i] = byteString.charCodeAt(i);
  }

  return new Blob([ia], { type: mimeString });
}

const getCollaborator = (id) => {
  EmployeeService.getEmployee(id)
    .then((res) => {
      collaborator.value = res.data;
      collaborator.value.provider = collaborator.value.provider['@id']
      title.value = 'Colaborador: ' + collaborator.value.name + ' ' + collaborator.value.lastName;
      // uiStore.setLoading(false);
      uiStore.stopLoading();
    })
    .catch(() => {
      Notification.addNotification('Error al intentar eliminar el empleado seleccionado.', 'error', 6000);
      // uiStore.setLoading(false);
      uiStore.stopLoading();
    })
}


const openModalCropImage = () => {
  console.log("openModalCropImage", baseUrl.value + imagePreview.value)

  // imageUrl.value = baseUrl.value + imagePreview.value;
  imageUrl.value = imagePreview.value ? "https://connectuspre.undanet.com/backend" + imagePreview.value : null;
  // imageUrl.value = "https://connectuspre.undanet.com/backend/documents/undanitas/producto11-6601d44b1b617345207743.jpg";
  showModalCropImage.value = true;

}
const closeModalCropImage = () => {
  showModalCropImage.value = !showModalCropImage.value;
}

const ifIsInArray = (userRoles, role) => {
  return Common.ifIsInArray(userRoles, role);
}

const goBackToCollaborators = () => {
  sessionStorage.setItem(collaboratorsRestoreFiltersStorageKey, 'true');
  router.push({ name: 'collaborators' });
}

const saveEmployee = async () => {
  v$.value.$reset();
  v$.value.$validate();
  v = v$.value;

  if (v$.value.$invalid) {
    Notification.addNotification({
      type: 'error',
      message: 'Error al crear el colaborador. Revise los campos marcados en rojo',
      duration: 6000
    })
  } else {
    if (isEditingCollaborator.value) {
      await editCollaborator();
    } else {
      await createCollaborator();
    }
  }
}

const editCollaborator = async () => {
  const params = {
    name: collaborator.value.name,
    lastName: collaborator.value.lastName,
    email: collaborator.value.email,
    emailExternal: collaborator.value.emailExternal,
    timeZoneSpain: collaborator.value.timeZoneSpain,
    countryLocation: collaborator.value.countryLocation,
    provider: collaborator.value.provider,
  }

  uiStore.startLoading();
  EmployeeService.updateEmployee(params, route.params.id)
    .then((res) => {
      uiStore.stopLoading();
      if (res.status === 200) {
        Notification.addNotification({ message: 'Colaborador actualizado correctamente', type: 'success' })
        getCollaborator(route.params.id)
        router.push(`/collaborators/`);
      }
    })
    .catch(() => {
      Notification.addNotification('Error al actualizar el empleado', 'error', 6000);
      uiStore.stopLoading();
    });

}


const createCollaborator = () => {
  const params = {
    name: collaborator.value.name,
    lastName: collaborator.value.lastName,
    email: collaborator.value.email,
    emailExternal: collaborator.value.emailExternal,
    timeZoneSpain: collaborator.value.timeZoneSpain,
    countryLocation: collaborator.value.countryLocation,
    employeeType: "external_collaborator",
    provider: collaborator.value.provider,
  }
  uiStore.startLoading();
  EmployeeService.createEmployee(params)
    .then((res) => {
      uiStore.stopLoading();
      if (res.status === 201) {
        Notification.addNotification({ message: 'Colaborador creado correctamente', type: 'success' })
        router.push('/collaborators');
      }
      return res;
    })
    .catch(() => {
      Notification.addNotification('Error al crear el colaborador', 'error', 6000);
      uiStore.stopLoading();
    })
}

const getProviders = (searchQuery = '') => {
  //const params = {query: {name: searchQuery}};
  const params = (searchQuery.length > 0 ? { name: searchQuery } : {});

  ProviderService.getProviders(params).then((res) => {
    providers.value = res.data['hydra:member'];
  })
}

</script>

<template>
  <div class="collaborator-item" v-if="user && ifIsInArray(user.roles, 'ROLE_ADMIN')">
    <HeaderTitle title="Producción"></HeaderTitle>

    <div class="row collaborator-item__top" v-if="!profile">
      <div class="col-md-1 col-12" style="text-align: left">
        <button type="button" class="return-btn btn btn-grey" style="padding-left: 0px; display:initial;"
          @click="goBackToCollaborators()">
          <font-awesome-icon icon="angle-left"></font-awesome-icon>
          Volver
        </button>
      </div>
      <div class="col-md-8 col-12 list-header">
        <h3>{{ title }}</h3>
      </div>
    </div>
    <hr>


    <!-- Form-->
    <form class="employee-form" @submit.prevent="saveEmployee(isEditingEmployee)" v-if="!uiStore.loading">

      <div class="subtitle">
        <svg style="width: 30px;" xmlns="http://www.w3.org/2000/svg" class="subtitle__search-icon"
          viewBox="0 0 1024 1024">
          <path
            d="M641.8 737.4c-66.4 47.3-147.7 75.2-235.5 75.2-224.4 0-406.3-181.9-406.3-406.3s181.9-406.3 406.3-406.3c224.4 0 406.3 181.9 406.3 406.3 0 87.8-27.8 169.1-75.2 235.5l266.9 266.9c26.3 26.3 26.1 68.4 0 94.5l-1.1 1.1c-26 26-68.4 26.1-94.5 0l-266.9-266.9zM406.3 717c171.6 0 310.7-139.1 310.7-310.7s-139.1-310.7-310.7-310.7c-171.6 0-310.7 139.1-310.7 310.7s139.1 310.7 310.7 310.7v0z" />
        </svg>
        <span class="subtitle__search-text">Colaboradores</span>
      </div>
      <div class="row undanita">
        <div class="col-md-2 col-12 collaborator-avatar-col" @click="openModalCropImage">
          <label class="pointer image">
            <!--                        <font-awesome-icon v-if="!image && !imagePreview" :icon="'upload'" title="Subir imagen"/>-->
            <img class="img-thumbnail rounded-circle" style="border: 1px solid blue;" v-if="!image && !imagePreview"
              src="~@/assets/images/user.png" title="Subir imagen" />
            <img class="img-thumbnail rounded-circle" v-if="!image && imagePreview" :src="baseUrl + imagePreview"
              :alt="'Employee image'" title="Click para cambiar imagen">
            <img class="img-thumbnail rounded-circle" v-if="image" :src="imagePreview" :alt="'Employee image'"
              title="Click para cambiar imagen">
          </label>
        </div>
        <div class="col-md-10 col-12 collaborator-main-col">
          <div class="row">
            <div class="col-md-6 col-12">
              <div class="form-item">
                <label for="">Nombre</label>
                <el-input :type="'text'" :param="'collaboratorName'" :color="'light'" :placeholder="'Nombre'"
                  v-model="collaborator.name" @change="collaborator.name = collaborator.name.trimEnd()" />
                <!-- Para hacer que al entrar si sale sin poner nada se valide automaticamente el nombre
                    @blur="v$.dni.$touch" -->
                <p v-if="v.name.$error" class="invalid-feedback mb-0">
                  <small>
                    {{ v.name.$errors[0].$message }}
                  </small>
                </p>
              </div>
            </div>
            <div class="col-md-6 col-12">
              <div class="form-item">
                <label for="" class="w-100">Apellidos</label>
                <el-input :type="'text'" v-model="collaborator.lastName" :param="'collaboratorLastName'"
                  :color="'light'" :placeholder="'Apellidos'"
                  @change="collaborator.lastName = collaborator.lastName.trimEnd()" />
                <p v-if="v.lastName.$error" class="invalid-feedback mb-0">
                  <small>
                    {{ v.lastName.$errors[0].$message }}
                  </small>
                </p>
              </div>
            </div>
          </div>
          <div>
            <div class="row d-flex">
              <div class="col-md-6 col-12">
                <div class="form-item">
                  <label class="w-100">Correo electrónico Undanet</label>
                  <el-input v-model="collaborator.email" type="email" :placeholder="'Correo electrónico'"
                    @change="collaborator.email = collaborator.email.trimEnd()" />
                  <p v-if="v.email.$error" class="invalid-feedback mb-0">
                    <small>
                      {{ v.email.$errors[0].$message }}
                    </small>
                  </p>
                </div>
              </div>

              <div class="col-md-6 col-12">
                <div class="form-item">
                  <label class="w-100">Correo Externo</label>
                  <el-input v-model="collaborator.emailExternal" type="email" :placeholder="'Correo personal'"
                    @input="collaborator.emailExternal = collaborator.emailExternal.trimEnd()" />
                  <p v-if="v.emailExternal.$error" class="invalid-feedback mb-0">
                    <small>
                      {{ v.emailExternal.$errors[0].$message }}
                    </small>
                  </p>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-3 col-12">
                <div class="form-item">
                  <label class="w-100">Pais Ubicacion</label>
                  <el-input v-model="collaborator.countryLocation" type="text" :placeholder="'País Ubicación'"
                    @change="collaborator.countryLocation = collaborator.countryLocation.trimEnd()" />
                  <p v-if="v.countryLocation.$error" class="invalid-feedback mb-0">
                    <small>
                      {{ v.countryLocation.$errors[0].$message }}
                    </small>
                  </p>
                </div>
              </div>

              <div class="col-md-3 col-12 collaborator-checkbox-col">
                <div class="form-item">
                  <label class="mt-4">Uso Horario España</label>
                  <el-checkbox v-model="collaborator.timeZoneSpain" />
                  <p v-if="v.timeZoneSpain.$error" class="invalid-feedback mb-0">
                    <small>
                      {{ v.timeZoneSpain.$errors[0].$message }}
                    </small>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <br>
      <div>
        <div class="subtitle__provider-data">
          <svg xmlns="http://www.w3.org/2000/svg" class="subtitle__provider-data-icon" viewBox="0 0 1024 1024">
            <path
              d="M539.4 226.3c-0.7-0.8-1.3-1.5-2.1-2.3-8.9-8-9.2-5.7 0.6-14.7 7.3-6.7 16.1-11.9 24-17.6 21.1-15.3 35-35.7 44.4-59.9 21.1-54.4-41-92-72.2-124.2-22.5-23.3-58 12.2-35.5 35.5 17.4 18 39.8 32.6 54.9 52.6 16.9 22.4-8.9 47.1-26.6 59.5-27.3 19.3-51 44.8-45.5 72.3-122.7 11.5-236.1 78.7-236.1 197.2v332.7c0 147 119.6 266.6 266.6 266.6 147 0 266.6-119.6 266.6-266.6v-332.8c0-129.4-120.4-192.1-239.2-198.4zM295.6 424.7c0-88 95.5-138.9 194.4-147.4v306.9c-90.2-4.5-163.5-25.1-194.4-35.1v-124.4zM728.4 757.4c0 119.3-97.1 216.4-216.4 216.4-119.3 0-216.4-97.1-216.4-216.4v-155.6c44.8 13.5 129.2 34.1 228.9 34.1 63.8 0 134-8.5 203.9-32.6v154.2zM728.4 549.9c-63.5 24.3-128.3 33.8-188.2 35v-308.4c96.8 5.8 188.2 52.2 188.2 148.2v125.2zM468.4 303.3v254.5c-39 6.9-153.6-25.2-153.6-25.2-16.9-178.4 49.9-209.8 153.6-229.3z" />
          </svg>
          <span class="subtitle__provider-data-text">PROVEEDOR</span>
        </div>

        <div class="company-data">
          <div class="row">
            <div class="col-md-6 col-12">

              <div class="row" style="margin-top: 10px">
                <div class="col-md-4 col-12 d-inline-flex align-items-center">
                  <label class="label-employee" for="department">Proveedor</label>
                </div>
                <div class="col-md-8 col-12">
                  <div class="form-item">
                    <el-select v-model="collaborator.provider" placeholder="Seleccione un proveedor" value-key="'@id'">
                      <el-option v-for="item in providers" :key="item.id" :label="item.legalName"
                        :value="item['@id']" />
                    </el-select>
                    <p v-if="v.provider.$error" class="invalid-feedback mb-0">
                      <small>
                        {{ v.provider.$errors[0].$message }}
                      </small>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <hr>
        <br>

        <!--                Botones de guardado-->
        <div class="row">
          <div class="col-md-12">
            <div class="d-flex justify-content-end collaborator-item__actions">
              <div class="col-md-2 col-12">
                <button type="button" class="btn btn-block btn_red align-content-center" style="height: 3em;"
                  @click="goBackToCollaborators()">Cancelar
                </button>
              </div>
              <div class="col-md-2 col-12">
                <button type="submit" class="btn btn-block btn_yellow align-content-center" style="height: 3em">
                  Guardar
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </form>

    <el-dialog v-model="showModalCropImage" :title="'Crop Foto Empleado'" width="500"
      :before-close="closeModalCropImage">
      <div>
        <Cropper class="cropper" :src="uploadedImage ? uploadedImage : imageUrl" ref="cropper" :stencil-props="{
          handlers: {
            eastNorth: true,
            westNorth: true,
            westSouth: true,
            eastSouth: true,
          },
          movable: true,
          scalable: true,
          aspectRatio: 1,
        }" @change="changePicture" />
        <!--                <div class="row" @click.stop="focusOnInputCrop($event)">-->
        <div class="row justify-content-center">
          <!--                    <div class="col text-center" style="margin: 10px">-->
          <div class="text-center col-md-6" style="margin-top: 10px">
            <label class="pointer image d-block" for="imageCrop">
              <span class="button">
                <input type="file" ref="imageCrop" id="imageCrop" name="imageCrop" @change="uploadImage($event)"
                  style="display: none" />
                {{ imagePreview ? "Cambiar imagen" : "Subir imagen" }}
              </span>
            </label>
          </div>

          <!--                    <div class="col text-center" style="margin: 10px">-->
          <div class="text-center col-md-6" style="margin-top: 10px">
            <span class="button" @click="cropImage">Recortar</span>
          </div>


        </div>
      </div>

    </el-dialog>
  </div>


</template>

<style lang="scss">
.vdp-datepicker__calendar-button {
  .input-group-text {
    width: 24px;
  }

}

.vdp-datepicker__clear-button {
  .input-group-text {
    i {
      span {
        font-size: 20px;
        font-style: normal;
        font-weight: 700;
      }
    }

  }
}
</style>

<style lang="scss" scoped>
.radio-larg {
  width: 25px;
  height: 25px;
}

.subtitle {
  display: flex;
  align-items: center;
  margin-bottom: 10px;

  .subtitle__search-icon {
    fill: $bg-blue;
    width: 45px;
    margin-right: 10px;
  }

  .subtitle__search-text {
    color: $bg-blue;
    letter-spacing: -0.05em;
    font-size: 2.5em;
    font-weight: bolder;
  }
}

.subtitle__provider-data {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
  margin-top: 10px;

  .subtitle__provider-data-icon {
    fill: $bg-blue;
    width: 35px;
    margin-right: 10px;
  }

  .subtitle__provider-data-text {
    color: $bg-blue;
    letter-spacing: -0.05em;
    font-size: 2em;
    font-weight: bolder;
    text-transform: uppercase;
  }
}

.el-date-editor {
  width: 32em;
}

.birthday.el-date-editor {
  width: 33em;
}

.collaborator-item {
  padding: 0px 0px 50px 0px;

  .form-item {
    label.image {
      display: inline-flex;
      justify-content: center;
      width: 100%;
      align-self: center;
    }
  }

  img {
    width: 100%;
    height: 100%;
    min-width: 110px;
    min-height: 110px;
    -o-object-fit: cover;
    object-fit: cover;
    margin: auto auto auto 0;
    display: block;
    border-radius: 50%;
  }

  .undanita {
    background-color: white;
    border-radius: 20px;
    padding: 10px 10px 30px 10px;
  }

  label.checkbox-label input[type=checkbox] {
    position: relative;
    vertical-align: middle;
    bottom: 1px;
  }

  .label-employee {
    color: #434343;
    float: left;
    display: block;
    white-space: nowrap;

  }

  .h3-employee {
    color: #434343;
    float: left;
  }


}

.table-users {
  /*padding: 40px;*/
  padding-top: 10px;

  table {
    width: 100%;
    color: #858796;

    th {
      border: 1px solid #e3e6f0;
      padding: 12px;
      padding-left: 20px;
      font-size: 20px;
      text-align: left;
    }

    tbody {
      .selected {
        background-color: rgba(0, 0, 0, .06);

        td {
          background-color: rgba(0, 0, 0, .06);
        }
      }

      tr:nth-child(odd) {
        td {
          background-color: rgba(0, 0, 0, .05);
        }
      }

      td {
        border: 1px solid #e3e6f0;
        padding: 12px;
        padding-left: 20px;
        text-align: left;

        a {
          font-size: 18px;
          color: #4e73df;
        }
      }
    }
  }
}

.modal_address {
  h2 {
    color: black;
  }

  li {
    color: black;
  }

  span {
    color: black;
  }
}

.upload-example-cropper {
  border: solid 1px #EEE;
  height: 300px;
  width: 100%;
}

.button-wrapper {
  display: flex;
  justify-content: center;
  margin-top: 17px;
}

.button {
  color: white;
  font-size: 16px;
  padding: 10px 20px;
  background: #3fb37f;
  cursor: pointer;
  transition: background 0.5s;
  display: block;
  border: solid 1px #EEE;
  border-radius: .25rem;
}

.button:hover {
  background: #38d890;
}

.button input {
  display: none;
}


.el-dialog__body {
  background: #f3f0fb !important;
  min-height: auto !important;

  .el-dialog__header {
    padding: 0;
  }

  .my-header {
    margin-top: 2px;
    display: flex;
    flex-direction: row;
    justify-content: space-between;

    .text-header {
      text-align: left;
      font-size: 4em;
      font-weight: 900;
      letter-spacing: -0.05em;
      color: #f9156f;
    }

    .close-icon {
      width: 8%;
      height: 20%;
    }

    .inter-icon {
      width: 2%;
      height: 2%;
    }

    #asterisk {
      position: absolute;
      vertical-align: super;
      height: auto;
      width: 2.2em;
      fill: #f9156f;
    }

  }

  .my-body {
    margin-right: 5%;
  }

}


.btn_unsubscribe {
  max-width: 200px;
  height: 42px;
}



.error_date {
  margin-top: 10px;
}

@media (max-width: 767px) {
  .collaborator-item {
    padding-right: 14px;
  }

  .collaborator-item__top {
    gap: 10px;
  }

  .collaborator-avatar-col {
    display: flex;
    justify-content: center;
    margin-bottom: 14px;
  }

  .collaborator-avatar-col .image {
    max-width: 140px;
  }

  .collaborator-main-col {
    padding-right: 0;
  }

  .subtitle__search-text {
    font-size: 2em !important;
  }

  .subtitle__provider-data-text {
    font-size: 1.5em !important;
  }

  .undanita {
    padding: 16px 14px 22px 14px !important;
  }

  .company-data {
    padding-right: 0;
  }

  .collaborator-checkbox-col .form-item {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
  }

  .collaborator-checkbox-col .form-item label {
    margin-top: 0 !important;
  }

  .collaborator-item__actions {
    flex-direction: column-reverse;
    align-items: stretch !important;
    gap: 10px;
  }

  .collaborator-item__actions .col-md-2 {
    width: 100%;
    max-width: 100%;
    padding-left: 0;
    padding-right: 0;
  }

  .collaborator-item__actions .btn {
    width: 100%;
  }

  .el-date-editor {
    width: 100%;
  }
}
</style>
